import { render, staticRenderFns } from "./BlockEditorText.vue?vue&type=template&id=918e4028&"
import script from "./BlockEditorText.vue?vue&type=script&lang=ts&"
export * from "./BlockEditorText.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports